import React, { Component } from "react";
import { connect } from "react-redux";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import AppLoader from "../../../app-components/app-loader.jsx";
import TrendingBarList from "../components/trending-bar-list.jsx";
import TrendingBarModal from "../components/trending-bar-modal.jsx";
import {
  fetchTrendingBar,
  submitTrendingBarItem,
  deleteTrendingBarItem,
  toggleTrendingBarModal,
  setTrendingBarModalData,
} from "../trending-bar-action.js";

class TrendingBarContainer extends Component {
  componentDidMount() {
    this.props.fetchTrendingBar();
  }

  render() {
    const {
      isLoading,
      items,
      showModal,
      modalData,
      toggleTrendingBarModal,
      submitTrendingBarItem,
      deleteTrendingBarItem,
      setTrendingBarModalData,
      fqdn,
    } = this.props;

    if (isLoading) return <AppLoader message="Loading Trending Bar Items" />;

    return (
      <>
        <TrendingBarList
          items={items}
          fqdn={fqdn}
          toggleTrendingBarModal={toggleTrendingBarModal}
          setTrendingBarModalData={setTrendingBarModalData}
          deleteTrendingBarItem={deleteTrendingBarItem}
        />
        <TrendingBarModal
          showModal={showModal}
          modalData={modalData}
          fqdn={fqdn}
          toggleTrendingBarModal={toggleTrendingBarModal}
          submitTrendingBarItem={submitTrendingBarItem}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    landingPages: {
      trendingBar: { isLoading, items, showModal, modalData },
    },
  } = state.tool;
  const { domainMap, activeDomain } = state.login.user;
  const activeDomainDetails = domainMap[activeDomain] && domainMap[activeDomain][0];
  const fqdn = activeDomainDetails ? activeDomainDetails.fqdn : '';
  return { isLoading, items, showModal, modalData, fqdn };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchTrendingBar: () => dispatch(fetchTrendingBar()),
    submitTrendingBarItem: (item) => dispatch(submitTrendingBarItem(item)),
    deleteTrendingBarItem: (itemId) => dispatch(deleteTrendingBarItem(itemId)),
    toggleTrendingBarModal: (flag) => dispatch(toggleTrendingBarModal(flag)),
    setTrendingBarModalData: (item) => dispatch(setTrendingBarModalData(item)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrendingBarContainer);
